import React from 'react'
import classnames from 'classnames'
import ButtonLink from './ButtonLink'
import Menu from './Menu'
import Logo from './Logo'
import headerStyles from './header.module.sass'

const text = 'Book Now'
const url =
  'https://reservation.hotello.com/reservit/reserhotel.php?lang=EN&hotelid=440782'
export default ({ allPages, slug, burgerColor }) => {
  let buttonClass

  switch (slug) {
    case 'home':
      buttonClass = classnames(headerStyles.buttonlink, headerStyles.homecta)
      break
    case 'bistro':
      buttonClass = classnames(headerStyles.buttonlink, headerStyles.bistrocta)
      break
    default:
      buttonClass = headerStyles.buttonlink
  }

  return (
    <header className={headerStyles.header}>
      <Menu
        pageWrapId="page-wrap"
        outerContainerId="outer-container"
        className="menu"
        allPages={allPages}
        burgerColor={burgerColor}
      />
      <Logo slug={slug} />
      <ButtonLink
        className="test"
        url={url}
        text={text}
        addClass={buttonClass}
      />
    </header>
  )
}
